import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Button } from "../../../components/Component";

const AnswerModal = ({ data,answer, isOpen, toggle, title }) => {
  console.log("data", answer);
  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle} className=" " >{title} : <span className="text-end">{data?.result}</span></ModalHeader>
        <ModalBody>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Question</th>
                <th scope="col">Answer</th>
              </tr>
            </thead>
            <tbody>
               {answer?.length>0&& answer?.map((item, index) => (
                <tr key={index}>
                  <th scope="row">{index + 1}</th>
                  <td>{item?.question}</td>
                  <td>{item?.selected_option}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </ModalBody>

        <ModalFooter>
          <Button color="danger" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AnswerModal;
